import DataKelas from '../../../views/Akademi/DataKelas/DataKelas.view';

export default DataKelas;
